import { atom } from 'recoil';

const signupValidAtom = atom<boolean>({
  key: 'signupValidAtom',
  default: false,
});

export { signupValidAtom };
